import ListViewContainer from "../../../components/miscellaneous/jobSearch/listView";

const ListView = () => {
  return <ListViewContainer />;
};

export default ListView;
